export const encodeIdToUuid = (id: number) => {
  const hexId = id.toString(16).padStart(32, '0'); // Convert ID to hex and pad to 32 characters
  const uuid = `${hexId.substring(0, 8)}-${hexId.substring(8, 12)}-${hexId.substring(12, 16)}-${hexId.substring(16, 20)}-${hexId.substring(20)}`;
  return uuid;
}